/*
 * Copyright (C) 2025 Musarubra US LLC.  All Rights Reserved.
 */

import { WidgetContext } from './widget-context-base';
import { iamLogin } from '../main';
import { WidgetElements } from '../elements/widget-elements-base';
import { iam } from '../iam';

export class ActivateTotpWidgetContext extends WidgetContext {
  constructor(elements: WidgetElements) {
    super(elements);
  }

  public override initialize() {
    if (iam.settings.debug) console.log('initializing otp activate widget');
    document.getElementById('dont-have-a-mvision').style.display = 'none';
    iamLogin.registerLocalizationCallback(() => {
      iamLogin.localizeElement('sub-header', 'otpAppSetup');
      iamLogin.localizeElement('sub-header-2', 'otpSubhead2');
    }, true, true);
    iamLogin.page.showCommonFields(['auth-footer', 'sub-header-2']);
    iamLogin.page.initializeCommon();
  }

  public override setInitialFocus() {
    const field = this.elements.getPasscodeField();
    if (field && !field.disabled) {
      field.focus();
    }
  }

  public override validateForm() {
    this.elements.getSubmitButton().disabled = this.elements.getPasscodeField().value.length === 0;
  }
}
